import React from 'react';
import { cn } from '../../../lib/utils';

type Size = 'sm' | 'md' | 'lg' | 'xl';
type Gradient = 'primary' | 'success' | 'warm';

export interface TaskyAvatarProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: Size;
  src?: string;
  alt?: string;
  initials?: string;
  gradient?: Gradient;
}

const sizeClass: Record<Size, string> = {
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-12 h-12 text-base',
  xl: 'w-16 h-16 text-lg',
};

const gradientClass: Record<Gradient, string> = {
  primary: 'bg-gradient-to-br from-primary to-purple',
  success: 'bg-gradient-to-br from-success to-primary',
  warm: 'bg-gradient-to-br from-warning to-pink',
};

export const TaskyAvatar = React.forwardRef<HTMLDivElement, TaskyAvatarProps>(
  ({ className, size = 'md', src, alt = '', initials, gradient, children, ...rest }, ref) => (
    <div
      ref={ref}
      {...rest}
      className={cn(
        'rounded-full flex items-center justify-center text-white font-medium overflow-hidden shrink-0',
        sizeClass[size],
        gradient ? gradientClass[gradient] : 'bg-gray-300',
        className,
      )}
    >
      {src ? (
        <img src={src} alt={alt} className="w-full h-full object-cover" />
      ) : (
        children ?? initials ?? '?'
      )}
    </div>
  ),
);
TaskyAvatar.displayName = 'TaskyAvatar';
